document.querySelectorAll('.table-of-contents__dropdown').forEach(dropdown => {
    const button = dropdown.querySelector('.table-of-contents__trigger');
    const menu = dropdown.querySelector('.table-of-contents__menu');
    const label = dropdown.querySelector('.table-of-contents__label');

    button.addEventListener('click', () => {
        dropdown.classList.toggle('is-open');

        button.setAttribute(
            'aria-expanded',
            dropdown.classList.contains('is-open')
        );
    });

    menu.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
            dropdown.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
        });
    });

    document.addEventListener('click', e => {
        if (!dropdown.contains(e.target)) {
            dropdown.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
        }
    });
});